<template>
  <model-form
    ref="modelForm"
    :model="kitchenDisplay"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-center q-mb-sm">
        <model-form-input
          field="name"
          class="col-8"
          label="Name"
          autofocus
          :rules="[val => !!val || 'Field is required']"
        />
        <model-form-input
          field="receiptPaperWidth"
          class="col-4"
          label="Printer Width (px)"
          type="number"
          min="100"
          max="1000"
          step="1"
          :rules="[
            val => val !== null || 'Field is required',
            val => val >= 100 || 'Cannot be less than 100' ,
            val => val <= 1000 || 'Must not exceed 1000'
          ]"
        />
      </div>
      <div class="row q-gutter-sm items-center q-mb-sm">
        <model-form-select
          field="kitchenDisplayType"
          class="col"
          label="Kitchen Display Type"
          :options="$_.filter(kitchenDisplayTypes.data, 'isUnarchived')"
          option-label="name"
          :rules="[val => !!val || 'Field is required']"
        />
      </div>
      <div class="row q-gutter-sm items-center">
        <model-form-select
          field="locationIds"
          class="col"
          label="Locations"
          stack-label
          :options="locations.data"
          option-label="displayName"
          option-value="id"
          map-options
          emit-value
          multiple
          use-chips
          :rules="[
            val => !!val || 'Field is required',
            val => val.length > 0 || 'At least one location must be selected'
          ]"
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'KitchenDisplayForm',
  components: {
    ModelForm
  },
  configuration: ['kitchenDisplayTypes', 'locations'],
  models: {
    kitchenDisplay: {
      kitchenDisplayType: {
        fields: ['id', 'name']
      },
      locations: {
        fields: ['id', 'name'],
        locationGroup: {
          fields: ['id', 'name']
        }
      }
    }
  }
}
</script>
